// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3J8iw","buttons":"Footer_buttons__44tsT"};